import { render, staticRenderFns } from "./associateAbnormal.vue?vue&type=template&id=eb1200b4&scoped=true&"
import script from "./associateAbnormal.vue?vue&type=script&lang=js&"
export * from "./associateAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./associateAbnormal.vue?vue&type=style&index=0&id=eb1200b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1200b4",
  null
  
)

export default component.exports